var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_1010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 7.87502V4.66669H1.16669V7.83337C1.16669 10.1904 1.16669 11.3689 1.92604 12.1011C2.62969 12.7796 3.73073 12.8294 5.83335 12.8331",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91669 10.7917H9.92269",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7003 10.5131C12.789 10.6375 12.8333 10.6996 12.8333 10.7917C12.8333 10.8837 12.789 10.9458 12.7003 11.0702C12.3019 11.6289 11.2844 12.8333 9.91667 12.8333C8.54898 12.8333 7.53142 11.6289 7.133 11.0702C7.04433 10.9458 7 10.8837 7 10.7917C7 10.6996 7.04433 10.6375 7.133 10.5131C7.53142 9.95441 8.54898 8.75 9.91667 8.75C11.2844 8.75 12.3019 9.95441 12.7003 10.5131Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16669 4.66669L1.72759 3.32053C2.16259 2.27652 2.3801 1.75451 2.82096 1.4606C3.26183 1.16669 3.82734 1.16669 4.95835 1.16669H9.04169C10.1727 1.16669 10.7382 1.16669 11.1791 1.4606C11.62 1.75451 11.8374 2.27652 12.2725 3.32053L12.8334 4.66669",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4.66669V1.16669",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 7H8.16665",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_1010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBooking);
export default __webpack_public_path__ + "static/media/viewBooking.6b05728ede48185f6cf417e6924acea3.svg";
export { ForwardRef as ReactComponent };